

export function Warning(message = "") {
    this.name = "Uyarı";
    this.message = message;
}

function ServiceError(message = "") {
    this.name = "Uyarı";
    this.message = message;
}

export function ValidationError(message = "") {
    this.name = "ValidationError";
    this.message = message;
}

Warning.prototype = Error.prototype;
ServiceError.prototype = Error.prototype;
ValidationError.prototype = Error.prototype;